module.exports = __webpack_public_path__ + "static/img/product1.f45bd552.jpg";